import { ref } from 'vue'
import { useSnackbarStore } from '@/ai_studio/stores/snackbar';
export { contextData }
const contextData = ref(null);

export const request = async (endpoint, messages = null, method='GET', body = null) => {
  if (!method || !endpoint) return;
  
  const snackbar = useSnackbarStore();
  try {
      const response = await fetch(endpoint, {
        method: method,
        body: body,
      });
      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message);
      }
      if (messages && messages?.success) snackbar.success(messages.success);
      return data.data;

  } catch (err) {
    if (messages && messages?.error) snackbar.error(messages.error);
    throw err;
  }
}

export const fetchContextos = async () => {
  const snackbar = useSnackbarStore();
  try {
      const response = await fetch("/api/assistents/crm/listContexts")
      const data = await response.json();
      if (!data.success) {
          throw new Error(data.message)
      }
      contextData.value = data.data;
      return data.data
  } catch (err) {
      snackbar.error('Não foi possível carregar as ofertas');
      throw err;
  }
}

export const fetchProperties = async () => {
    try {
        const response = await fetch('/api/assistents/crm/fields');
        const data = await response.json();
        if (!data.success) {
            throw new Error(data.message);
        }
        return data.data;
    } catch (err) {
        console.error(err)
        throw err;
    }
}
